import styled from "styled-components";
import { Text } from "@ficatranquilo/contabilidade.com-ui";

// Rodapé da área de conteúdo, no lugar do rodapé do ft-app-web (55px, linha N100
// em cima, conteúdo até 1440px com 30px nas laterais). Em fluxo, no fim da coluna:
// nunca position fixed/absolute.
const Footer = styled.footer`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 55px;
  border-top: 1px solid ${({ theme }) => theme.colors.N100};
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  max-width: ${({ theme }) => theme.breakpoints.desktop};
  padding: 15px 30px;
`;

const Link = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  img {
    display: block;
    width: auto;
    height: 14px;
  }
`;

export default function PoweredBy() {
  return (
    <Footer>
      <Content>
        <Link href="https://contabilidade.com/" target="_blank" rel="noopener noreferrer">
          <Text $text="powered by" $variant="caption_medium" $color="N400" />
          <img src="/contabilidade-com.svg" alt="Contabilidade.com" />
        </Link>
      </Content>
    </Footer>
  );
}
